import React from "react";

type Props = {
  children: React.ReactNode;
  icon: React.ReactNode;
  clickEvent?: () => void;
};

export default function SocialButton({ children, icon, clickEvent }: Props) {
  return (
    <button
      type="button"
      className={[
        "w-full h-[42px] rounded-[8px] bg-white",
        "border border-primary text-[#0F172A] text-sm font-medium",
        "flex items-center justify-center gap-2 hover:bg-black/[0.02] transition"
      ].join(" ")}
      onClick={() => clickEvent && clickEvent()}
    >
      <span className="text-black/65">{icon}</span>
      {children}
    </button>
  );
}

export const GIcon = () => (
  <svg width="16" height="16" viewBox="0 0 533.5 544.3"><path fill="#4285f4" d="M533.5 278.4c0-18.6-1.7-37.1-5.2-55.1H272.1v104.3h147.2c-6.3 34-25.2 63-53.7 82.4v68h86.7c50.8-46.8 81.2-115.9 81.2-199.6z"/><path fill="#34a853" d="M272.1 544.3c72.6 0 133.7-24 178.3-65.2l-86.7-68c-24.1 16.2-55 25.7-91.6 25.7-70.4 0-130.1-47.5-151.5-111.3H31.1v69.9c44.9 89.1 136.9 148.9 241 148.9z"/><path fill="#fbbc04" d="M120.6 325.5c-10.3-30.6-10.3-63.9 0-94.6V161H31.1C-10.3 242-10.3 343 31.1 424l89.5-69z"/><path fill="#ea4335" d="M272.1 107.7c39.5-.6 77.5 14.2 106.2 41.5l79.1-79.1C406.1 23.9 340.2-.8 272.1 0 168 0 76 59.8 31.1 148.9l89.5 69c21.3-63.8 81.1-110.2 151.5-110.2z"/></svg>
);

export const FbIcon = () => (
  <svg width="16" height="16" viewBox="0 0 24 24"><path fill="currentColor" d="M22 12.06C22 6.5 17.52 2 12 2S2 6.5 2 12.06c0 5 3.66 9.14 8.44 9.94v-7.03H7.9v-2.9h2.54v-2.2c0-2.5 1.5-3.88 3.8-3.88 1.1 0 2.24.2 2.24.2v2.47h-1.26c-1.24 0-1.63.77-1.63 1.56v1.86h2.78l-.44 2.9h-2.34v7.03C18.34 21.2 22 17.05 22 12.06Z"/></svg>
);
